<template>
  <AppIcon icon="mdi:trash-outline" color="error" />
</template>